import { type ApolloError } from '@apollo/client'
import { TicketingPoliciesDocument } from 'generated/resources/graphql'
import { useQuery } from 'modules/core/hooks/useQuery'

interface UseTicketingPoliciesResult {
  loading: boolean
  error: ApolloError | undefined
  canViewTicketing: boolean
  canViewSettings: boolean
  canViewInsights: boolean
  aiEnabled: boolean
}

export const useTicketingPolicies = (): UseTicketingPoliciesResult => {
  const { data, loading, error } = useQuery(TicketingPoliciesDocument)
  const policies = data?.ticketing._policies

  return {
    loading,
    error,
    canViewTicketing: policies?.viewTicketing.can ?? false,
    canViewSettings: policies?.viewTicketingSettings.can ?? false,
    canViewInsights: policies?.viewTicketingInsights.can ?? false,
    aiEnabled: policies?.aiFeatures.can ?? false,
  }
}
